import { call, put, all } from "redux-saga/effects";

export const getSubDomain = () => {
    var subdomain = window.location.host.split(".")[1] ? window.location.host.split(".")[0] : null;
    return subdomain;
};

export const extractErrorMessage = (error: any, defaultMessage = "Please try again") => {
    if (typeof error === "string") {
        return error;
    } else {
        if (error && error.response && error.response.message && error.response.message.length) {
            return error.response.message[0];
        } else if (error && error.data && error.data.errors && Object.keys(error.data.errors).length) {
            return error.data.errors[Object.keys(error.data.errors)[0]];
        } else if (error && error.data && error.data.message) {
            return error.data.message;
        } else if (error && error.message) {
            return error.message;
        } else if (error && error.clientMessage) {
            return error.clientMessage;
        } else {
            return defaultMessage;
        }
    }
};

export function* sagaFunction(
    action: any,
    apiCallType: any,
    apiUrl: any,
    data: any,
    isAuth: any,
    yieldPuts?: any
): any {
    try {
        const resp = yield call(apiCallType, apiUrl, data, isAuth);
        if (resp.status >= 200 && resp.status < 300 && resp.data) {
            if (yieldPuts?.length) {
                let respData: any = resp.data.data;
                let c = 0;
                yield all(
                    yieldPuts.map((x: any, i: any) =>
                        put({
                            type: x.type,
                            payload: x.payload
                                ? x.payload.split(".")?.map((p: any) => {
                                      if (c != i) {
                                          respData = resp.data.data;
                                          c = i;
                                      }
                                      respData = respData[p];
                                      return respData;
                                  })[x.payload.split(".").length - 1]
                                : resp.data.data,
                        })
                    )
                );
            }
            action && action.callbackSuccess && action.callbackSuccess(resp.data);
        } else {
            action && action.callbackError && action.callbackError(resp.data.errorMessage);
        }
    } catch (e: any) {
        action && action.callbackError && action.callbackError(e && e.data ? e.data : e);
    }
}

export const apiCaller = (callApi: any, action: string) => {
    return (data: any, onSuccess: Function, onError: Function) => {
        callApi(action, data, onSuccess, onError);
    };
};

export const actionDispatcher =
    (dispatch: any, type: string) =>
    (payload: any = null) => {
        dispatch({ type, payload });
    };
